import type { IUpdateUserEducationApiPayload } from '~/domain/UpdateOffice';
import type { IUserCredentials } from '~/models/UserCredentials';
import { SoftwareUtils } from '~/utils/SoftwareUtils';

interface ICredentialsParts {
  specialty: string;
  /** Display names, general and X-ray already merged into one list. */
  softwares: string[];
  insurances: string[];
}

/**
 * The credentials PATCH replaces the whole object, so specialty, software and
 * insurance always travel together — editing one section never drops the
 * others. Software goes back under its stored (untranslated) names.
 */
export const buildCredentialsPatch = ({
  specialty,
  softwares,
  insurances,
}: ICredentialsParts): IUpdateUserEducationApiPayload => ({
  education: {
    specialtiesAndProcedures: { [specialty]: [] },
    softwares: SoftwareUtils.getSoftwareOriginalValues(softwares),
  },
  insurances,
});

/** The credentials as they read after `patch` was saved. */
export const applyCredentialsPatch = (
  credentials: IUserCredentials | null | undefined,
  patch: IUpdateUserEducationApiPayload,
): IUserCredentials => ({
  educationUpdatedAt: credentials?.educationUpdatedAt ?? null,
  ...credentials,
  education: { ...credentials?.education, ...patch.education },
  insurances: patch.insurances,
});
